import { api } from './api';

// Define a service using a base URL and expected endpoints
export const documentApi = api.injectEndpoints({
  reducerPath: 'documentApi',
  endpoints: (builder) => ({
    uploadAnonymizedFile: builder.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `public/api/documents/${id}/uploadAnonymizedFile`,
          method: 'POST',
          body: formData
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: 'Entities', id },
        { type: 'EntityMarkers', id },
        { type: 'EntityRelationships', id }
      ]
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUploadAnonymizedFileMutation } = documentApi;
